import * as React from 'react';
import * as THREE from "three";
import { VrmAvatar } from '../com/akavirtual/deai/VrmAvatar';
import  {useDEAIService, EVENT_AI_AUDIO_ENQUEUED}  from "../com/akavirtual/deai/core/DEAIService";
import { Config } from '../com/akavirtual/deai/Config';
import { BloomEffect, EffectComposer, EffectPass, RenderPass, ToneMappingEffect, ToneMappingMode } from "postprocessing";

const ThreejsCanvas = () => {
    const canvasRef = React.useRef(null);
    const deAIService = useDEAIService(Config.ENDPOINT);

    React.useEffect(() => {
      const canvas = canvasRef.current;
      if (canvas === null) {
        return;
      }
      console.log("[ThreejsCanvas] Init");
      // シーンの生成
      const scene = new THREE.Scene();

      // カメラの生成
      const camera = new THREE.PerspectiveCamera(
        30, canvas.clientWidth/canvas.clientHeight, 0.1, 20);
      camera.position.set(0.0, 1.3, -1.5);
      camera.rotation.set(0.0, Math.PI, 0.0);

      // レンダラーの生成
      const renderer = new THREE.WebGLRenderer({
        powerPreference: "high-performance",
        antialias: false,
        stencil: false,
        depth: false
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(canvas.clientWidth, canvas.clientHeight);
      renderer.setClearColor(0x0, 0.0);
      const composerLoading = new EffectComposer(renderer);
      composerLoading.addPass(new RenderPass(scene, camera));
      composerLoading.addPass(new EffectPass(camera, new BloomEffect({
        intensity: 1,
        radius: 0.6,
        luminanceThreshold: 0.249,
        luminanceSmoothing: 0.2,
      })));
      const composerNormal = new EffectComposer(renderer);
      composerNormal.addPass(new RenderPass(scene, camera));
      composerNormal.addPass(new EffectPass(new ToneMappingEffect()));
      canvas.appendChild(renderer.domElement);
      let composer = composerLoading;
        // camera controls
        // const controls = new OrbitControls( camera, renderer.domElement );
        // controls.screenSpacePanning = true;
        // controls.target.set( 0.0, 1.0, 0.0 );
        // controls.update();

      // ライトの生成
      const light = new THREE.DirectionalLight(0xffffff, Math.PI);
      light.position.set(1.0, 1.0, 1.0);
      scene.add(light);

      // VRM要素の準備
      const vrmAvatar = new VrmAvatar(scene, camera);
      vrmAvatar.load("./avatar/lucy.loading.vrm");
      vrmAvatar.load("./common/animations/shiryu_idle.vrma");
      vrmAvatar.preloadGLTF("./avatar/lucy.full.vrm").then((gltf)=>{
        vrmAvatar.fadeOutPreview();
        composer = composerNormal;
        setTimeout(()=> vrmAvatar.initializeVRM(gltf, false));
      })
        // dnd handler
        window.addEventListener( 'dragover', function ( event ) {
            event.preventDefault();
        } );

        window.addEventListener( 'drop', async function ( event ) {
            event.preventDefault();

            // read given file then convert it to blob url
            const files = event.dataTransfer?.files;
            if ( ! files ) {
                return;
            }

            const file = files[ 0 ];
            if ( ! file ) {
                return;

            }

            const blob = new Blob( [ file ], { type: "application/octet-stream" } );
            const url = URL.createObjectURL( blob );
            const gltf = await vrmAvatar.preloadGLTF( url );
            vrmAvatar.initializeVRM(gltf, false);

        } );
        window.addEventListener("resize", () => {
          if(renderer && camera) {
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize(  canvas.clientWidth, canvas.clientHeight );

            camera.aspect = canvas.clientWidth/ canvas.clientHeight ;
            camera.updateProjectionMatrix();
        }
        });
      // clockの準備
      const clock = new THREE.Clock();
      clock.start();


      const handleAIAudioEnqueued = async () => {
        try { 
          if(!vrmAvatar.stillSpeeking && deAIService.audioQueue.length > 0) {
            const rawBlob = deAIService.audioQueue.shift();
            const audioBlob = new Blob([rawBlob], {type: "audio/wav"});
            await vrmAvatar.speek(audioBlob);
          }
        } catch(e) {
          console.log(e);
        }
      }
      // フレーム毎に呼ばれる
      const update = () => {
        requestAnimationFrame(update);
        const deltaTime = clock.getDelta();
        vrmAvatar.update(deltaTime);
        // renderer.render(scene, camera);
        composer.render();
        handleAIAudioEnqueued();
      }
      update();
      // deAIService.addEventListener(EVENT_AI_AUDIO_ENQUEUED, handleAIAudioEnqueued);
      // return () => {
      //   deAIService.removeEventListener(EVENT_AI_AUDIO_ENQUEUED, handleAIAudioEnqueued);
      // };
    }, [deAIService]);


    return (
        <div id="threeView" className="threeView" style={{width: '100%',height: '100%'}} ref={canvasRef} />
    );
  };
  
  export default ThreejsCanvas;